import * as _ from 'lodash';
import { fromJS } from 'immutable';

import * as actions from '../actions/case';
import { fetchingState } from '@constants';

const initialState = fromJS({
  activeCase: null,
  data: {},
  state: null,
  summary: {},
  rollCorrs: [],
  backCase: {},
});

export default (state = initialState, action) => {
  switch (action.type) {
    case actions.SET_BACK_CASE: {
      return state.set('backCase', fromJS(action.data));
    }
    case actions.CREATE_CASE_START: {
      return state.setIn(['state'], fetchingState.FETCHING);
    }
    case actions.CREATE_CASE_SUCCESS:
      return state
        .setIn(['state'], fetchingState.LOADED)
        .setIn(['data'], fromJS(_.get(action, 'data.results[0]', [])));
    case actions.CREATE_CASE_ERROR: {
      return state.setIn(['state'], fetchingState.ERROR);
    }

    case actions.FETCH_CASE_START: {
      return state.setIn(['state'], fetchingState.FETCHING);
    }
    case actions.FETCH_CASE_SUCCESS: {
      return state
        .setIn(['state'], fetchingState.LOADED)
        .setIn(['data'], fromJS(_.get(action, 'data.results[0]', {})));
    }
    case actions.FETCH_CASE_ERROR: {
      return state.setIn(['state'], fetchingState.ERROR);
    }

    case actions.UPDATE_CASE_START:
    case actions.REOPEN_CASE_START: {
      return state.setIn(['state'], fetchingState.FETCHING);
    }
    case actions.UPDATE_CASE_SUCCESS:
    case actions.REOPEN_CASE_SUCCESS: {
      return state
        .setIn(['data'], fromJS(_.get(action, 'data.results[0]', [])))
        .setIn(['state'], fetchingState.LOADED);
    }
    case actions.UPDATE_CASE_ERROR:
    case actions.REOPEN_CASE_ERROR: {
      return state.setIn(['state'], fetchingState.ERROR);
    }
    case actions.UPDATE_CASE_TAX_YEARS_SUCCESS: {
      return state.setIn(['data'], fromJS(_.get(action, 'data.results[0]')));
    }

    case actions.FETCH_ROLL_CORRS_SUCCESS: {
      return state.setIn(
        ['rollCorrs'],
        fromJS(_.get(action, 'data.results', [])),
      );
    }

    case actions.SET_ACTIVE_CASE: {
      return state.setIn(['activeCase'], action.payload);
    }
    case actions.RESET_ACTIVE_CASE: {
      return state.setIn(['activeCase'], null);
    }

    case actions.FETCH_CASE_SUMMARY_SUCCESS: {
      return state.setIn(['summary'], fromJS(_.get(action, 'data.results[0]')));
    }

    default: {
      return state;
    }
  }
};
